import {
  QuantityDetailsDtoStatusEnum,
  type OfferDto,
  type OfferingDto,
  OfferingDtoOfferScopeEnum,
} from '@b-stock/offering-api-client'

export const hasUserWonAnOffering = ({
  offering,
  offers,
  ignoreOffers,
  loggedInAccountId,
}: {
  offering: OfferingDto | null
  offers: OfferDto[] | null
  ignoreOffers: boolean
  loggedInAccountId: string
}): boolean => {
  if (ignoreOffers) {
    return false
  }

  // This logic was added specifically for offerScope = LOT offerings.
  // In older implementations (prior to LOT),
  // the `winningAccountIds` field may not be set for every winner.
  // especially "Classic MOA" with multi-winners offerings
  // Ideally, this field *should* always be populated,
  // but to avoid potential breaking changes in legacy scenarios
  // we will just apply it only to offerScope = LOT offerings
  if (offering && offering.offerScope === OfferingDtoOfferScopeEnum.Lot) {
    if (!offering.winningAccountIds?.includes(loggedInAccountId)) {
      return false
    }
    return true
  }

  return (offers ?? []).some((offer) =>
    (offer.offer.quantities ?? []).some(
      (quantity) => quantity.status === QuantityDetailsDtoStatusEnum.Accepted
    )
  )
}
